module.exports = __webpack_public_path__ + "img/gallery-3.e0ca4288.jpg";